// react
import React from "react";

// @mui
import { Box, Grid, Paper, Typography, useTheme } from "@mui/material";
import { CallReceived as CallReceivedIcon, AccountCircle as AccountCircleIcon, Tag as TagIcon } from "@mui/icons-material";

// utils
import convertTimestamp from "utils/convertTimestamp";

// A ---------------------------------------------------------------------- M

const GroupToolbar = ({ group }) => {
  const theme = useTheme();

  return (
    <Grid container>
      <Grid item xs={12}>
        <Paper
          elevation={0}
          sx={{
            p: 3,
            borderRadius: 4,
            background: `linear-gradient(180deg, ${theme.palette.background.paper}, ${theme.palette.background.default}F2)`,
            backdropFilter: "blur(10px)",
            border: `1px solid ${theme.palette.divider}`,
            boxShadow: "0 6px 20px rgba(0,0,0,0.12)",
            display: "flex",
            flexDirection: "column",
            gap: 2.5,
          }}
        >
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              flexWrap: "wrap",
              gap: 1.5,
            }}
          >
            <Typography variant="h5" fontWeight={700} sx={{ letterSpacing: "0.3px" }}>
              {group.name || "N/A"}
            </Typography>
          </Box>

          <Box sx={{ display: "flex", flexWrap: "wrap", gap: 2 }}>
            <Box sx={{ display: "flex", alignItems: "center", gap: 0.7 }}>
              <TagIcon sx={{ fontSize: 18, color: theme.palette.text.disabled }} />
              <Typography variant="body2" color="text.secondary">
                {group.id}
              </Typography>
            </Box>

            <Box sx={{ display: "flex", alignItems: "center", gap: 0.7 }}>
              <CallReceivedIcon sx={{ fontSize: 18, color: theme.palette.text.disabled }} />
              <Typography variant="body2" color="text.secondary">
                {group.created_on ? convertTimestamp(group.created_on) : "N/A"}
              </Typography>
            </Box>

            <Box sx={{ display: "flex", alignItems: "center", gap: 0.7 }}>
              <AccountCircleIcon sx={{ fontSize: 18, color: theme.palette.text.disabled }} />
              <Typography variant="body2" color="text.secondary">
                {group.creator_email || "N/A"}
              </Typography>
            </Box>
          </Box>
        </Paper>
      </Grid>
    </Grid>
  );
};

export default GroupToolbar;
